import { render } from "./OnetoFiveImageDiv.vue?vue&type=template&id=166f7224&scoped=true&ts=true"
import script from "./OnetoFiveImageDiv.vue?vue&type=script&lang=ts"
export * from "./OnetoFiveImageDiv.vue?vue&type=script&lang=ts"

import "./OnetoFiveImageDiv.vue?vue&type=style&index=0&id=166f7224&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-166f7224"]])

export default __exports__